import { Link } from "react-router-dom";
import ContactForm from "./ContactFrom";
import { CallIcon, LocationIcon, MailIcon } from "../common/Icons";
import Title from "../common/Title";
import Para from "../common/Para";

const ProjectQuote = () => {
  return (
    <div className="relative xl:pt-18 lg:pt-16 pt-12">
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative z-10">
        <div className="pb-10 xl:pb-14 flex flex-col gap-4">
          <Title text="Get in Touch With Us" myClass="text-center" />
          <Para
            text="Reach out with questions, feedback, or travel dreams—we’re here to help!"
            myClass="text-center"
          />
        </div>
        <div className="grid lg:grid-cols-2 sm:gap-12 gap-10 items-center sm:p-5  shadow-[0px_0px_10px_5px_#f7f7f7] rounded-[24px]">
          <div className="w-full bg-[#026A91] rounded-3xl text-white sm:py-8 py-6 sm:px-7 px-5 lg:max-w-[550px] h-full">
            <h3 className="sm:text-[32px] text-[28px] xl:text-[40px] font-medium drop-shadow-[0px_4px_4px_0px_#00000040] leading-[110%] pb-2">
              Contact Information
            </h3>
            <p className="max-sm:text-sm text-base font-normal opacity-70 tracking-[0.5px]  pt-2 max-w-[350px]">
              If you need any type of help or have any query please contact us
            </p>
            <div className="flex  sm:gap-4 gap-3 sm:mt-8 mt-5">
              <span>
                <LocationIcon />
              </span>
              <div>
                <p className="text-offWhite font-medium text-base">Address</p>
                <p className="text-base font-normal opacity-70 tracking-[0.5px] text-offWhite py-1.5">
                  123 Explorer Lane, Wanderlust City, 10001
                </p>
              </div>
            </div>
            <div className="flex sm:gap-4 gap-3 sm:mt-6 mt-4">
              <span>
                <CallIcon />
              </span>
              <div>
                <p className="text-offWhite font-medium text-base">Phone</p>
                <Link
                  to="tel:  +1 (800) 555-TRIP"
                  className="text-base font-normal opacity-70 tracking-[0.5px] text-offWhite py-1.5"
                >
                  +1 (800) 555-TRIP
                </Link>
              </div>
            </div>
            <div className="flex sm:gap-4 gap-3 sm:mt-6 mt-4">
              <span>
                <MailIcon />
              </span>
              <div>
                <p className="text-offWhite font-medium text-base">Email</p>
                <Link
                  to="mailto: support@myservices.org.in"
                  className="text-base font-normal opacity-70 tracking-[0.5px] text-offWhite py-1.5"
                >
                  support@tripnest.com
                </Link>
              </div>
            </div>
          </div>
          <div className="w-full ">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectQuote;
